@use "/src/styles/functions.scss";
@use "/src/styles/mixins";

@mixin size {
  width: functions.space(40);
  height: functions.space(40);
}

@mixin selected {
  &:not([data-disabled="true"]) {
    background-color: functions.getThemeColor(bg-weak-50);
  }
}

.selected {
  @include selected();
}

.icon-border {
  border: 1px solid functions.getThemeColor(stroke-soft-200);
  @include size();
}

.icon-container {
  border-radius: functions.radius(full);
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  display: block;
  @include size();
  border-radius: inherit;
}
.image-disabled {
  opacity: 48%;
}

.box {
  display: flex;
  gap: functions.space(8);
  border-radius: functions.radius(10);
  padding: functions.space(8);
  cursor: pointer;
  &:hover {
    @include selected();
  }
  &[data-disabled="true"] {
    color: functions.getThemeColor("text-disabled-300") !important;
    cursor: not-allowed;
  }
}

.row {
  display: flex;
  justify-content: space-between;
}

.wrap {
  flex-wrap: wrap;
}

.alignCenter {
  align-items: center;
}

.column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.noShrink {
  flex-shrink: 0;
}

.grow {
  flex-grow: 1;
}

.gap4 {
  gap: functions.space(4);
}

.autoAlignment {
  /* Or what selector you need */
  unicode-bidi: plaintext;

  /* Align text automatically left/right*/
  text-align: start;
}

.entityContent {
  &__description {
    max-width: functions.toRem(350);

    @include mixins.respond(xs) {
      min-width: functions.toRem(450);
    }
  }
}
